import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import './PageTitle.scss'

function PageTitle(props) {
    const classes = cx('ao-pagetitle', props.className)
    return (
        <h1 className={ classes }>{ props.children }</h1>
    )
}

PageTitle.propTypes = {
    className: PropTypes.string
}

export default PageTitle
